import React from "react";
import UserLayout from "../layout/UserLayout";
import AboutUs from "../components/AboutUs";
import WhyChooseUs from "../components/WhyChooseUs";
import SocialMedia from "../components/SocialMedia";

const About = () => {
  return (
    <UserLayout>
      {/* Hero Banner */}
      <div className="relative bg-gradient-to-r from-emerald-950 via-teal-950 to-stone-900 text-white pt-32 pb-20 px-6 sm:px-12 text-center">
        <div className="max-w-4xl mx-auto">
          <span className="text-amber-400 font-semibold tracking-widest text-sm uppercase">
            Our Island Heritage
          </span>
          <h1 className="text-4xl sm:text-5xl font-extrabold mt-3 mb-4 tracking-tight">
            About Ceymos Lanka
          </h1>
          <p className="text-lg text-emerald-100 max-w-2xl mx-auto leading-relaxed">
            Rooted in Sri Lanka. Shared with the world. We bring the authentic treasures of Ceylon to international markets with uncompromising purity and ethics.
          </p>
        </div>
      </div>

      {/* Main Story & Heritage */}
      <AboutUs />

      {/* Why Choose Us & Certifications */}
      <WhyChooseUs />

      {/* Community & Global Presence */}
      <SocialMedia />
    </UserLayout>
  );
};

export default About;
